import {APIMethod, fetchData} from "@client";

export async function removeCompanyApiKeyQuery(id) {
    return fetchData(`/company/apikeys/${id}`, APIMethod.DELETE);
}
